/* === K+K Pre-Checkout Acknowledgment === */
/* Restored from kk-acknowledgment-builder (final_v3).
   Previously pasted inline in theme.liquid before </body>; now loaded as an asset.

   >>> YOUR OPTIS KEYWORD RULES GO IN "var O" BELOW. <<<
   Open kk-acknowledgment-builder_final_v3.html in the same browser you built it in
   (your saved rules load automatically), open the JS Code tab, and copy the
   contents of the "var O = { ... }" block over the one below.
   Format:  "keyword in option text": "special"  or  "nonstock"            */
(function(){
  "use strict";

  /* OPTIS keyword rules (from builder). Tiers: special=2, nonstock=1. */
  var O = {
    /* PASTE YOUR SAVED RULES HERE, e.g.
    "Special Order": "special",
    "Built to Order": "nonstock"
    */
  };

  /* Product tag names — must match the Liquid snippet. */
  var TAG_SPECIAL = "special-order";
  var TAG_NONSTOCK = "non-stock";

  var MSG = {
    specialHead: "Custom-Built Items in Your Cart",
    specialBody: "Some items in your cart are built specifically for your order. Please review your selections — custom-built items are final sale and can't be canceled or returned once production begins.",
    specialAck: "Looks good — I've reviewed my custom items.",
    nonstockHead: "A quick note about your order",
    nonstockBody: "Some items in your cart ship from the manufacturer and are subject to a 50% restocking fee if returned.",
    showItems: true
  };

  /* Cache: product handle → server-side tier. Seeded from initial Liquid render,
     then populated via /products/{handle}.js for AJAX-added items. */
  var handleTierCache = {};

  function tierVal(t){ return t==="special"?2:t==="nonstock"?1:0; }

  function readInitialTiers(){
    try{
      var el = document.getElementById("kkAckCartData");
      if(!el) return;
      var data = JSON.parse(el.textContent);
      (data.items || []).forEach(function(it){
        if(it.handle){
          var prev = handleTierCache[it.handle];
          if(!prev || tierVal(it.tier) > tierVal(prev)) handleTierCache[it.handle] = it.tier;
        }
      });
    }catch(e){}
  }

  function fetchHandleTier(handle){
    if(handleTierCache[handle] != null) return Promise.resolve(handleTierCache[handle]);
    return fetch("/products/" + encodeURIComponent(handle) + ".js", {credentials:"same-origin"})
      .then(function(r){ return r.json(); })
      .then(function(p){
        var tier = "stock";
        var tags = p && p.tags ? p.tags : [];
        if(Array.isArray(tags)){
          for(var i=0; i<tags.length; i++){
            if(tags[i] === TAG_SPECIAL){ tier = "special"; break; }
            if(tags[i] === TAG_NONSTOCK) tier = "nonstock";
          }
        }
        handleTierCache[handle] = tier;
        return tier;
      })
      .catch(function(){ handleTierCache[handle] = "stock"; return "stock"; });
  }

  function getOptisTier(line){
    var best = 0;
    var props = line.properties || {};
    var optisKeys = Object.keys(O);
    if(!optisKeys.length) return best;
    Object.keys(props).forEach(function(pk){
      if(pk.charAt(0) === "_") return;
      var pv = props[pk];
      if(pv == null) return;
      var pvStr = String(pv);
      for(var i=0; i<optisKeys.length; i++){
        var kw = optisKeys[i];
        if(pvStr.indexOf(kw) !== -1){
          best = Math.max(best, tierVal(O[kw]));
        }
      }
    });
    return best;
  }

  function combineLine(serverTier, optisTierNum){
    var best = Math.max(tierVal(serverTier), optisTierNum);
    return best === 2 ? "special" : best === 1 ? "nonstock" : "stock";
  }

  function escHtml(s){ return String(s||"").replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;"); }

  function buildSpecialBox(items){
    var itemsHtml = "";
    if(MSG.showItems && items.length){
      itemsHtml = '<ul class="kk-ack-items">';
      items.forEach(function(it){ itemsHtml += '<li>' + escHtml(it) + '</li>'; });
      itemsHtml += '</ul>';
    }
    return '<div class="kk-ack-box kk-ack-special">'
      + '<div class="kk-ack-head"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#7a5a18" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg><span class="kk-ack-title">' + escHtml(MSG.specialHead) + '</span></div>'
      + '<p class="kk-ack-body">' + escHtml(MSG.specialBody) + '</p>'
      + itemsHtml
      + '<label class="kk-ack-check"><input type="checkbox" id="kk-ack-checkbox"><span>' + escHtml(MSG.specialAck) + '</span></label>'
      + '</div>';
  }

  function buildNonstockBox(items){
    var itemsHtml = "";
    if(MSG.showItems && items.length){
      itemsHtml = '<ul class="kk-ack-items">';
      items.forEach(function(it){ itemsHtml += '<li>' + escHtml(it) + '</li>'; });
      itemsHtml += '</ul>';
    }
    return '<div class="kk-ack-box kk-ack-nonstock">'
      + '<div class="kk-ack-title">' + escHtml(MSG.nonstockHead) + '</div>'
      + '<p class="kk-ack-body">' + escHtml(MSG.nonstockBody) + '</p>'
      + itemsHtml
      + '</div>';
  }

  function findCheckoutControls(){
    var sels = [
      'button[name="checkout"]',
      'input[name="checkout"]',
      '#checkout',
      '.checkout-button',
      '[name="goto_pp"]',
      '[name="goto_gc"]',
      'a[href*="/checkout"]'
    ];
    var found = [];
    sels.forEach(function(sel){
      try{
        var els = document.querySelectorAll(sel);
        for(var i=0; i<els.length; i++) if(found.indexOf(els[i])===-1) found.push(els[i]);
      }catch(e){}
    });
    return found;
  }

  function lockCheckout(){
    findCheckoutControls().forEach(function(b){
      b.classList.add("kk-ack-blocked");
      b.setAttribute("data-kk-ack-locked","1");
      if(b.tagName === "BUTTON" || b.tagName === "INPUT") b.disabled = true;
    });
  }
  function unlockCheckout(){
    findCheckoutControls().forEach(function(b){
      b.classList.remove("kk-ack-blocked");
      b.removeAttribute("data-kk-ack-locked");
      if(b.tagName === "BUTTON" || b.tagName === "INPUT") b.disabled = false;
    });
  }

  function interceptCheckout(){
    document.addEventListener("click", function(e){
      var t = e.target;
      var btn = t.closest ? t.closest('[data-kk-ack-locked]') : null;
      if(btn){
        e.preventDefault();
        e.stopPropagation();
        var cb = document.getElementById("kk-ack-checkbox");
        if(cb){
          cb.focus();
          var box = document.querySelector(".kk-ack-special");
          if(box){
            box.scrollIntoView({behavior:"smooth", block:"center"});
            box.style.transition = "transform 0.3s";
            box.style.transform = "scale(1.02)";
            setTimeout(function(){ box.style.transform = ""; }, 300);
          }
        }
        return false;
      }
    }, true);

    document.addEventListener("submit", function(e){
      var f = e.target;
      if(!f) return;
      /* Only intercept if a checkout-related button submitted the form.
         Add-to-cart, cart-update, and quantity changes pass through unaffected. */
      var s = e.submitter;
      if(!s) return;
      var isCheckout = false;
      try{
        isCheckout = s.matches && s.matches('button[name="checkout"], input[name="checkout"], #checkout, .checkout-button, [name="goto_pp"], [name="goto_gc"], a[href*="/checkout"]');
      }catch(err){ isCheckout = false; }
      if(!isCheckout) return;
      var allCbs = document.querySelectorAll('#kk-ack-checkbox');
      var anyChecked = false;
      allCbs.forEach(function(cb){ if(cb.checked) anyChecked = true; });
      var specialShowing = !!document.querySelector(".kk-ack-special");
      if(specialShowing && allCbs.length && !anyChecked){
        e.preventDefault();
        e.stopPropagation();
        if(allCbs[0]) allCbs[0].focus();
        var box = document.querySelector(".kk-ack-special");
        if(box) box.scrollIntoView({behavior:"smooth", block:"center"});
        return false;
      }
    }, true);
  }

  function getMount(){
    var m = document.getElementById("kk-ack-mount");
    if(m) return m;
    var btn = findCheckoutControls()[0];
    if(!btn) return null;
    m = document.createElement("div");
    m.id = "kk-ack-mount";
    var parent = btn.closest("form") || btn.parentElement;
    if(parent) parent.insertBefore(m, parent.firstChild);
    if(!document.getElementById("kk-ack-styles")){
      var s = document.createElement("style");
      s.id = "kk-ack-styles";
      s.textContent = "#kk-ack-mount:empty{display:none;}.kk-ack-box{margin:14px 0;font-family:inherit;}.kk-ack-special{background:#FDF8E6;border:1px solid #E5D4A6;border-radius:6px;padding:14px 18px;}.kk-ack-special .kk-ack-head{display:flex;align-items:center;gap:8px;margin-bottom:6px;}.kk-ack-special .kk-ack-title{font-size:14px;font-weight:600;color:#7a5a18;}.kk-ack-special .kk-ack-body{font-size:13.5px;line-height:1.55;color:#5d4310;margin:0;}.kk-ack-special .kk-ack-items{margin:8px 0 0;padding-left:20px;font-size:13px;color:#5d4310;}.kk-ack-special .kk-ack-check{display:flex;align-items:flex-start;gap:10px;margin-top:12px;padding:8px 10px;background:#fff;border-radius:4px;cursor:pointer;}.kk-ack-special .kk-ack-check input{margin-top:2px;width:16px;height:16px;flex-shrink:0;accent-color:#7a5a18;}.kk-ack-special .kk-ack-check span{font-size:13px;color:#5d4310;}.kk-ack-nonstock{border-left:3px solid #ccc;padding:6px 0 6px 12px;margin:10px 0;}.kk-ack-nonstock .kk-ack-title{font-size:11.5px;font-weight:600;color:#444;margin-bottom:3px;}.kk-ack-nonstock .kk-ack-body{font-size:12.5px;line-height:1.55;color:#666;font-style:italic;margin:0;}.kk-ack-nonstock .kk-ack-items{margin:4px 0 0;padding-left:16px;font-size:11.5px;color:#777;font-style:italic;}.kk-ack-blocked{opacity:0.5;pointer-events:none;cursor:not-allowed !important;}";
      document.head.appendChild(s);
    }
    return m;
  }

  function getItemTitle(line){
    var t = line.product_title || line.title || "Item";
    if(line.variant_title && line.variant_title !== "Default Title") t += " — " + line.variant_title;
    return t;
  }

  function evaluateAndRender(){
    fetch("/cart.js", {credentials: "same-origin"})
      .then(function(r){ return r.json(); })
      .then(function(cart){
        var items = cart.items || [];
        var unknownHandles = [];
        items.forEach(function(line){
          if(line.handle && handleTierCache[line.handle] == null){
            if(unknownHandles.indexOf(line.handle) === -1) unknownHandles.push(line.handle);
          }
        });
        var fetches = unknownHandles.map(function(h){ return fetchHandleTier(h); });
        return Promise.all(fetches).then(function(){
          var specialItems = [];
          var nonstockItems = [];
          items.forEach(function(line){
            var serverTier = (line.handle && handleTierCache[line.handle]) || "stock";
            var optisNum = getOptisTier(line);
            var finalTier = combineLine(serverTier, optisNum);
            if(finalTier === "special") specialItems.push(getItemTitle(line));
            else if(finalTier === "nonstock") nonstockItems.push(getItemTitle(line));
          });
          renderBoxes(specialItems, nonstockItems);
        });
      })
      .catch(function(){});
  }

  function renderBoxes(special, nonstock){
    var firstMount = getMount();
    if(!firstMount) return;
    var html = "";
    if(nonstock.length && !special.length) html += buildNonstockBox(nonstock);
    if(special.length){
      if(nonstock.length) html += buildNonstockBox(nonstock);
      html += buildSpecialBox(special);
    }
    /* Populate ALL mount divs on the page (cart page + drawer + any others) */
    var allMounts = document.querySelectorAll('[data-kk-ack="1"], #kk-ack-mount');
    if(allMounts.length === 0){ firstMount.innerHTML = html; }
    else { allMounts.forEach(function(m){ m.innerHTML = html; }); }

    if(special.length){
      lockCheckout();
      /* Attach listeners to ALL checkboxes and keep them synced */
      var allCbs = document.querySelectorAll('#kk-ack-checkbox');
      allCbs.forEach(function(cb){
        cb.addEventListener("change", function(){
          allCbs.forEach(function(other){ if(other !== cb) other.checked = cb.checked; });
          if(cb.checked) unlockCheckout();
          else lockCheckout();
        });
      });
    } else {
      unlockCheckout();
    }
  }

  function hookCartChanges(){
    var evts = ["cart:updated","cart:refresh","cart:change","cart.requestComplete","ajaxProduct:added","variant:change"];
    evts.forEach(function(e){
      document.addEventListener(e, function(){ setTimeout(evaluateAndRender, 200); });
      window.addEventListener(e, function(){ setTimeout(evaluateAndRender, 200); });
    });

    var origFetch = window.fetch;
    if(origFetch){
      window.fetch = function(){
        var args = arguments;
        var url = (typeof args[0] === "string") ? args[0] : (args[0] && args[0].url) || "";
        var p = origFetch.apply(this, args);
        if(url && /\/cart\/(add|change|update|clear)/.test(url)){
          p.then(function(){ setTimeout(evaluateAndRender, 250); }).catch(function(){});
        }
        return p;
      };
    }

    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function(method, url){
      this.addEventListener("load", function(){
        if(typeof url === "string" && /\/cart\/(add|change|update|clear)/.test(url)){
          setTimeout(evaluateAndRender, 250);
        }
      });
      return origOpen.apply(this, arguments);
    };
  }

  function init(){
    readInitialTiers();
    interceptCheckout();
    hookCartChanges();
    evaluateAndRender();
  }

  if(document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();

})();
